var _a;
import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";
import TertiaryButton from "./TertiaryButton";
import UtilityPrimary from "./UtilityPrimary";
import UtilityTertiary from "./UtilityTertiary";
import { ButtonRoles } from "./types";
export var buttonRoleMap = (_a = {},
    _a[ButtonRoles.primary] = PrimaryButton,
    _a[ButtonRoles.secondary] = SecondaryButton,
    _a[ButtonRoles.tertiary] = TertiaryButton,
    _a[ButtonRoles.utilityPrimary] = UtilityPrimary,
    _a[ButtonRoles.utilityTertiary] = UtilityTertiary,
    _a);
